import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { EventoFeriaComponent } from '../evento-feria/evento-feria.component';
import { EventoComponent } from '../evento/evento.component';

import { EventoFeriaEscolarComponent } from './../evento-feria-escolar/evento-feria-escolar.component';
import { EventoFeriaPersonalizadaComponent } from '../evento-feria-personalizada/evento-feria-personalizada.component';
import { EventoYincanaComponent } from '../evento-yincana/evento-yincana.component';

@Component({
  selector: 'app-start-demo',
  templateUrl: './start-demo.component.html',
  styleUrls: ['./start-demo.component.scss'],
})
export class StartDemoComponent implements OnInit {
  public faCheckCircle = faCheckCircle;
  public faTimesCircle = faTimesCircle;
  public usuario = null;
  public isLoading = false;

  constructor(
    private svUtils: UtilsService,
    private dialog: MatDialog,
    private svUsuario: UsuarioService
  ) {}

  ngOnInit(): void {
    localStorage.setItem('ed', 'true');
    this.getLoggedUser();
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();

    if (this.usuario.id_empresa_perteneciente) {
      this.getCompany(this.usuario.id_empresa_perteneciente);
    }
  }

  openMarketplaceEventModal() {
    this.isLoading = true;
    this.svUsuario.getInfoDemos(this.usuario.id_usuario).subscribe(
      (resp_demos) => {
        //console.log(resp_demos)
        this.isLoading = false;

        if (
          resp_demos.puede_crear_demo ||
          Object.keys(resp_demos.demo).length == 0
        ) {
          const dialogRef = this.dialog.open(EventoComponent, {
            autoFocus: false,
            restoreFocus: true,
            hasBackdrop: true,
            data: {},
          });
        } else {
          //ALERTA DEMOS
          Swal.fire(
            'No se puede crear demo',
            `Ya cuentas con un demo activo, debes esperar a que caduque para poder crear uno nuevo. Días restantes disponibles del demo activo: ${resp_demos.dias_disponibles}`, //
            'warning'
          );
        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  openFeriaEventModal() {
    this.isLoading = true;
    this.svUsuario.getInfoDemos(this.usuario.id_usuario).subscribe(
      (resp_demos) => {
        console.log(resp_demos);
        this.isLoading = false;

        if (
          resp_demos.puede_crear_demo ||
          Object.keys(resp_demos.demo).length == 0
        ) {
          const dialogRef = this.dialog.open(EventoFeriaComponent, {
            autoFocus: false,
            restoreFocus: true,
            hasBackdrop: true,
            data: {},
          });
        } else {
          //ALERTA DEMOS
          Swal.fire(
            'No se puede crear demo',
            `Ya cuentas con un demo activo, debes esperar a que caduque para poder crear uno nuevo. Días restantes disponibles del demo activo: ${resp_demos.dias_disponibles}`, //
            'warning'
          );
        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  openFeriaEscolarEventModal() {
    this.isLoading = true;
    this.svUsuario.getInfoDemos(this.usuario.id_usuario).subscribe(
      (resp_demos) => {
        //console.log(resp_demos)
        this.isLoading = false;

        if (
          resp_demos.puede_crear_demo ||
          Object.keys(resp_demos.demo).length == 0
        ) {
          const dialogRef = this.dialog.open(EventoFeriaEscolarComponent, {
            autoFocus: false,
            restoreFocus: true,
            hasBackdrop: true,
            data: {},
          });
        } else {
          //ALERTA DEMOS
          Swal.fire(
            'No se puede crear demo',
            `Ya cuentas con un demo activo, debes esperar a que caduque para poder crear uno nuevo. Días restantes disponibles del demo activo: ${resp_demos.dias_disponibles}`, //
            'warning'
          );
        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  openYincanaEventModal() {
    this.isLoading = true;
    this.svUsuario.getInfoDemos(this.usuario.id_usuario).subscribe(
      (resp_demos) => {
        //console.log(resp_demos)
        this.isLoading = false;

        if (
          resp_demos.puede_crear_demo ||
          Object.keys(resp_demos.demo).length == 0
        ) {
          const dialogRef = this.dialog.open(EventoYincanaComponent, {
            autoFocus: false,
            restoreFocus: true,
            hasBackdrop: true,
            data: {},
          });
        } else {
          //ALERTA DEMOS
          Swal.fire(
            'No se puede crear demo',
            `Ya cuentas con un demo activo, debes esperar a que caduque para poder crear uno nuevo. Días restantes disponibles del demo activo: ${resp_demos.dias_disponibles}`, //
            'warning'
          );
        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  openFeriaPersonalizadaEventModal() {
    this.isLoading = true;
    this.svUsuario.getInfoDemos(this.usuario.id_usuario).subscribe(
      (resp_demos) => {
        //console.log(resp_demos)
        this.isLoading = false;

        if (
          resp_demos.puede_crear_demo ||
          Object.keys(resp_demos.demo).length == 0
        ) {
          const dialogRef = this.dialog.open(EventoFeriaPersonalizadaComponent, {
            autoFocus: false,
            restoreFocus: true,
            hasBackdrop: true,
            data: {},
          });
        } else {
          //ALERTA DEMOS
          Swal.fire(
            'No se puede crear demo',
            `Ya cuentas con un demo activo, debes esperar a que caduque para poder crear uno nuevo. Días restantes disponibles del demo activo: ${resp_demos.dias_disponibles}`, //
            'warning'
          );
        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getCompany(id_empresa_usuario) {
    this.svUsuario.getCompany(id_empresa_usuario).subscribe((resp) => {
      if (resp['status'] === 'success') {
        resp = resp['body']['data'][0];
        localStorage.setItem('empresa', JSON.stringify(resp));
      }
    });
  }
}
